export function create_UUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}
export function getTimeStamp() {

const currentTimestamp = Date.now();

const date = new Date(currentTimestamp);
date.setUTCMinutes(date.getUTCMinutes() + 330); 
const year = date.getUTCFullYear();
const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
const day = date.getUTCDate().toString().padStart(2, '0');
const hours = date.getUTCHours().toString().padStart(2, '0');
const minutes = date.getUTCMinutes().toString().padStart(2, '0');
const seconds = date.getUTCSeconds().toString().padStart(2, '0');

const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}-05:30`;

return formattedDateTime
  }
  
  

export const  HeaderforLoginOtpSocket={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.loginOtp.01"
}

export const  HeaderforVerifyOtpSocket={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.loginOtpVerify.01"
}

export const  MobileVerificationSocket={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.mobileVerification.01"
}

export const  MobileVerificationVerifySocket={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:res.mobileVerificationVerify.01"
}

export const  UserLinkedAccountHeader={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.userLinkedAccount.01"
}

export const  AccountDiscoveryHeader={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.discover.01"
}

export const  AccountDiscoveryasync={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.discoverAsync.01"
}

export const  AccountLinkingHeader={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.linking.01"
}


export const  AccountConfirmLinkingHeader={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.confirm-token.01"
}

export const  ConsentRequestDetail={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.consentRequestDetails.01"
}

export const  ConsentApprovalHeader={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.accountConsentRequest.01"
}


export const  ConsentRevoke={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.consent-revoke.01"
}

export const  ConsenthandleStatusCheck={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.consentHandleStatus.01"
}

export const  Logout={
    mid:create_UUID(),
    ts:getTimeStamp(),
    sid:"",
    dup:false,
    type: "urn:finvu:in:app:req.logout.01"
}